import { useState, useEffect, useRef } from "react";

import { API_URL, scroll, getValFromLS } from "../../helpers";

import Hdg from "../../components/Hdg";
import Notice from "../../components/Notice";
import Alert from "../../components/Alert";
import Input from "../../components/Input";
import Msg from "../../components/Msg";
import Submit from "../../components/Submit";

import Nav from "../Nav";
import Form from "./Form";

const Venues = () => {
	const [user, setUser] = useState({});
	const [details, setDetails] = useState({});
	const [results, setResults] = useState([]);
	const [errors, setErrors] = useState([]);
	const [names, setNames] = useState({});
	const [msg, setMsg] = useState({});
	const [notice, setNotice] = useState({});
	const [alert, setAlert] = useState({
		type: "working",
		text: "",
	});

	const formElement = useRef(null);

	useEffect(() => {
		const init = async () => {
			const token = getValFromLS("vtoUserToken")
				? getValFromLS("vtoUserToken")
				: "";
			const url = new URL(`${API_URL}/admin/venuesInit`);
			const params = {
				token,
			};
			url.search = new URLSearchParams(params);

			try {
				const response = await fetch(url, {
					method: "GET",
					cache: "no-store",
				});
				const json = await response.json();
				if (json && json.resp === 1) {
					setUser({ ...json.user });
					setAlert({});
					scroll();
				} else {
					setAlert({
						type: json.resp === 2 ? "notice" : "error",
						text: json.text,
					});
				}
			} catch (error) {
				setAlert({
					type: "error",
					text: "An error has occurred.",
				});
			}
		};

		init();
	}, []);

	const handleUpdate = (name, value) => {
		setNames((names) => ({ ...names, [name]: value ? value : "" }));
	};

	const handleSubmit = async (e = null, id = 0) => {
		if (e) {
			e.preventDefault();
		} else {
			formElement.current.registrationStr.value = id;
			handleUpdate("registrationStr", id);
			setResults([]);
		}
		setErrors([]);
		setMsg({
			type: "working",
			text: "",
		});
		setDetails({});

		const url = new URL(`${API_URL}/admin/venues`);
		let data = new FormData();
		Object.entries(names).forEach(([key, value]) => {
			if (key === "registrationStr" && id) {
				data.append(key, id);
			} else {
				data.append(key, value);
			}
		});
		data.append("token", getValFromLS("vtoUserToken"));

		try {
			const response = await fetch(url, {
				method: "POST",
				body: data,
			});
			const json = await response.json();
			if (json && json.resp === 1) {
				setMsg({
					type: "success",
					text: json.text,
				});

				setDetails({ ...json });
			} else if (json && json.resp === 2) {
				if (json.results.length === 1) {
					handleMatch(json.results[0].id);
				} else {
					setResults(json.results);
					setMsg({
						type: "notice",
						text: json.text,
					});
				}
			} else {
				setErrors(json.fields);
				setMsg({
					type: "error",
					text: json.text,
				});
			}
		} catch (error) {
			setMsg({
				type: "error",
				text: "An error has occurred.",
			});
		}
	};

	const handleMatch = async (id) => {
		handleSubmit(null, id);
	};

	const handleClick = () => {
		formElement.current.registrationStr.value = "";
		setNames({});
		setDetails({});
		setMsg({});
	};

	const handleSuccess = (text) => {
		scroll();
		setNotice({ type: "success", text });
	};

	return (
		<>
			{alert.type ? (
				<Alert data={alert} />
			) : (
				<>
					<div id="left-column">
						<Hdg section="Assign Venues" admin={true} />

						<p>
							Use this form to locate submitted BFC registrations and assign
							venues to foursomes.
						</p>

						{notice.type && <Notice data={notice} />}

						<div className="spacer"></div>

						<form
							ref={formElement}
							method="post"
							action="/"
							onSubmit={(e) => handleSubmit(e)}
							className="well"
						>
							<div className="form-group">
								<Input
									name="registrationStr"
									label="Registration ID / Organization Name"
									reqd={true}
									value={names.registrationStr || ""}
									update={handleUpdate}
									errors={errors}
									note="Note: Use partial company name if exact match is not found"
								/>

								<div className="empty" />
							</div>

							<div className="msg-submit" style={{ marginTop: "30px" }}>
								{msg.type && <Msg data={msg} />}

								<div
									className={
										msg.type === "working" ||
										msg.type === "notice" ||
										msg.type === "success"
											? "hidden"
											: "submit-container"
									}
								>
									<Submit submit="Locate Registration" />
								</div>
							</div>

							<div className="results-container">
								{results.map((item) => {
									return (
										<button
											type="button"
											className="naked"
											key={item.id}
											onClick={(e) => handleMatch(item.id)}
										>
											{`${item.id} ${item.name}`}
										</button>
									);
								})}
							</div>
						</form>

						{details.id && (
							<>
								<div className="reset-container">
									<button type="button" className="naked" onClick={handleClick}>
										<i className="fa fa-times-circle-o fa-lg working" />
									</button>
								</div>

								<table className="approved assigned">
									<thead>
										<tr>
											<th colSpan="4" className="hdg">
												{`${details.level.name} - ID ${details.id}`}
											</th>
										</tr>
										<tr>
											<td style={{ width: "33%" }}>Name</td>
											<td style={{ width: "34%" }}>Organization</td>
											<td style={{ width: "33%" }}>Email</td>
										</tr>
									</thead>
									<tbody>
										<tr>
											<td className="center">{details.name}</td>
											<td className="center">{details.organization}</td>
											<td className="center">
												<a href={`mailto:${details.email}`}>{details.email}</a>
											</td>
										</tr>
									</tbody>
								</table>

								{details.golfGroups.length > 0 && (
									<Form
										registrationId={details.id}
										event="golf"
										success={handleSuccess}
										groups={details.golfGroups}
										data={details.courses}
									/>
								)}

								{details.sportingGroups.length > 0 && (
									<Form
										registrationId={details.id}
										event="sporting"
										success={handleSuccess}
										groups={details.sportingGroups}
										data={details.ranches}
									/>
								)}
							</>
						)}

						<div className="spacer"></div>
					</div>

					<div id="right-column">
						<Nav on={4} user={user} />
					</div>
				</>
			)}
		</>
	);
};

export default Venues;
